import { useState } from 'react';
import AlertCard from '../../../../shared/alert-card';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

const SLACK_USER_TOKEN_PREFIX = 'xoxp-';

export interface SlackTokenFormProps {
  userToken?: string;
  setUserToken?: (token: string) => void;
  hasError?: boolean;
  onSubmit?: () => void;
}

export default function SlackTokenForm({
  userToken: propUserToken,
  setUserToken: propSetUserToken,
  hasError = false,
  onSubmit,
}: SlackTokenFormProps = {}) {
  const [internalUserToken, setInternalUserToken] = useState('');
  const userToken =
    propUserToken !== undefined ? propUserToken : internalUserToken;
  const setUserToken = propSetUserToken ?? setInternalUserToken;

  const trimmedToken = userToken.trim();
  const hasInvalidPrefix =
    trimmedToken.length > 0 &&
    !trimmedToken.startsWith(SLACK_USER_TOKEN_PREFIX);

  return (
    <Box
      component="form"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.();
      }}
      sx={{ width: '100%' }}
    >
      <Stack spacing={3} sx={{ mt: '24px', pt: hasError ? 0 : '24px' }}>
        {hasError && (
          <AlertCard
            severity="warning"
            message="You must create a Slack service account and add it to target Slack channels."
          />
        )}
        <TextField
          label="Slack User Token"
          value={userToken}
          onChange={(event) => setUserToken(event.target.value)}
          type="password"
          autoComplete="off"
          fullWidth
          required
          error={hasInvalidPrefix}
          helperText={
            hasInvalidPrefix
              ? 'Slack user tokens start with xoxp-.'
              : 'Connect Slack by pasting a user token for the workspace admin account gPanel should act as'
          }
        />
      </Stack>
    </Box>
  );
}
